import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "role-list-content"
};
import AppFilterBlock from '@/views/permissionManage/components/AppFilterBlock.vue';
import AppTableBlock from '@/views/permissionManage/components/AppTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'appPermission',
  setup(__props) {
    const tableRef = ref();
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchUser(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(AppFilterBlock, {
        onFilterSubmit: filterSubmit
      }), _createVNode(AppTableBlock, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});